import { render } from "./PendingValidation.vue?vue&type=template&id=578343b7&scoped=true"
import script from "./PendingValidation.vue?vue&type=script&lang=js"
export * from "./PendingValidation.vue?vue&type=script&lang=js"

import "./PendingValidation.vue?vue&type=style&index=0&id=578343b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578343b7"]])

export default __exports__